import { PageTemplate } from '../../components/PageTemplate';
import { TermTemplate } from './TermTemplate';

const SLUG = 'politica-de-privacidade';

export const PrivacyPolicy = () => {
  return (
    <PageTemplate title="Politica de privacidade">
      <TermTemplate slug={SLUG} />
    </PageTemplate>
  );
};
